import PropTypes from 'prop-types';
import { FC, ReactNode, useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import Login from 'src/content/pages/Auth/Login/Basic';
import useAuth from 'src/hooks/useAuth';

interface AuthenticatedProps {
  children: ReactNode;
}

const Authenticated: FC<AuthenticatedProps> = (props: { children: any }) => {
  const { children } = props;
  const { isAuthenticated, logout, user } = useAuth();
  const location = useLocation();
  const [requestedLocation, setRequestedLocation] = useState<string | null>(
    null
  );

  useEffect(() => {
    if (isAuthenticated && !user?.workspaces?.length) {
      logout();
    }
  }, [isAuthenticated, user, logout]);

  if (!isAuthenticated) {
    if (location.pathname !== requestedLocation) {
      setRequestedLocation(location.pathname);
    }
    return <Login />;
  }

  if (requestedLocation && location.pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return isAuthenticated && user?.workspaces?.length ? (
    <>{children}</>
  ) : (
    <Navigate to={'/status/404'} />
  );
};

Authenticated.propTypes = {
  children: PropTypes.node
};

export default Authenticated;
